// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/style_" + chunkId + "_" + {"155":"794cab8c","350":"794cab8c"}[chunkId] + "_1793007815409.css";
};